import { useMeuPlayState } from "@src/states/meuplay";
import {
  getInitialOfflineModeState,
  useOfflineModeState,
} from "@src/states/offline_mode";
import { getInitialPlayerState, usePlayerState } from "@src/states/player";

import { player } from "@src/services/player";
import { playerOverlays } from "@src/services/playerOverlays";

import { dispatchEventToNative } from "@src/utils/dispatchEventToNative";

export function logout() {
  // Descarta overlays (TTS, agendados, sob demanda) pendentes/tocando antes de
  // esvaziar o player, senão continuariam rodando contra a sessão desmontada.
  playerOverlays.clear();
  player.removeAllTracks().then(() => {
    const volume = useMeuPlayState.getState().volume;
    const initialMeuPlayState = useMeuPlayState.getInitialState();
    useMeuPlayState.setState(
      {
        ...initialMeuPlayState,
        volume,
      },
      true,
    );

    useOfflineModeState.setState(getInitialOfflineModeState(), true);
    usePlayerState.setState(getInitialPlayerState(), true);

    dispatchEventToNative("logout");
  });
}
